import { object, string, array } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

export default () => {
    const { REQUIRED_TEXT } = getValidationTexts();

    return object().shape({
        name: string().required(REQUIRED_TEXT),
        first_lastname: string().required(REQUIRED_TEXT),
        second_lastname: string().nullable(),
        business_name: string().nullable(),
        telephones: array().of(
            object().shape({
                telephone: string().required(REQUIRED_TEXT), // Requerido si se agrega
                phone_type: string().nullable(), // Opcional
            }),
        ),
        emails: array().of(
            object().shape({
                email: string().required(REQUIRED_TEXT), // Requerido si se agrega
                email_type: string().nullable(), // Opcional
            }),
        ),
    });
};
